export enum OrganizationType {
  Company = 1,
  Group = 2,
}
